import { CustomTabPanel } from "@/erp";
import { texto, a11yProps, ROUTER_PATHS, useTabsFormOnly } from "@/shared";
import { FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { EstadoSolicitudTransferencia } from "@/shared/interfaces";
import InventoryIcon from '@mui/icons-material/Inventory';
import SolicitudTransferenciaInventarioTable from "./componente/SolicitudTransferenciaInventarioTable";

export default function SolicitudTransferenciaInventarioPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 0
  });


  const navigate = useNavigate();

  return (
    <SingleTableBoxScene
      title="Solicitud Transferencia de Inventario"
      iconCreateOrEdit={<InventoryIcon />}
      textCreateOrEditBtn='Crear una Solicitud'
      enableCreateOrEditBtn={true}
      fnCreateOrEdit={async () => {
        navigate(ROUTER_PATHS.inventario.solicitudInventarioCrearNav);
      }}
    >

      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label={texto.espera} {...a11yProps(0)} />
          <Tab label={texto.aprobado} {...a11yProps(1)} />
          <Tab label={texto.rechazadas} {...a11yProps(2)} />
          <Tab label={texto.finalizado} {...a11yProps(2)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      <CustomTabPanel index={valueTab} value={0}>
        <SolicitudTransferenciaInventarioTable estado={EstadoSolicitudTransferencia.EN_ESPERA} />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={1}>
        <SolicitudTransferenciaInventarioTable estado={EstadoSolicitudTransferencia.APROBADO} />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={2}>
        <SolicitudTransferenciaInventarioTable estado={EstadoSolicitudTransferencia.RECHAZADO} />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={3}>
        <SolicitudTransferenciaInventarioTable estado={EstadoSolicitudTransferencia.FINALIZADO} />
      </CustomTabPanel>

    </SingleTableBoxScene>
  );

}